/**
 * Generated by orval v8.12.1 🍺
 * Do not edit manually.
 * Verdi Dashboard API
 * API for the Verdi Dashboard application
 * OpenAPI spec version: 1.0.0
 */

import type {
	DataTag,
	DefinedInitialDataOptions,
	DefinedUseQueryResult,
	MutationFunction,
	QueryClient,
	QueryFunction,
	QueryKey,
	UndefinedInitialDataOptions,
	UseMutationOptions,
	UseMutationResult,
	UseQueryOptions,
	UseQueryResult,
} from "@tanstack/react-query";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { customFetch } from "../custom-fetch";
import type {
	CreateSensoterraDevice400,
	CreateSensoterraDevice403,
	CreateSensoterraDevice500,
	CreateSensoterraDevice502,
	DeleteSensoterraDevice400,
	DeleteSensoterraDevice404,
	DeleteSensoterraDevice500,
	GetSensoterraDevice400,
	GetSensoterraDevice404,
	GetSensoterraDevice500,
	ListSensoterraDevices400,
	ListSensoterraDevices500,
	Sensoterradevices,
	SensoterradevicesCreate,
	SensoterradevicesUpdate,
	UpdateSensoterraDevice400,
	UpdateSensoterraDevice404,
	UpdateSensoterraDevice500,
} from "./schemas";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const getListSensoterraDevicesUrl = () => {
	return `/sensoterra-devices`;
};

/**
 * @summary List all Sensoterra devices owned by the authenticated user
 */
export const listSensoterraDevices = async (
	options?: RequestInit,
): Promise<Sensoterradevices[]> => {
	return customFetch<Sensoterradevices[]>(getListSensoterraDevicesUrl(), {
		...options,
		method: "GET",
	});
};

export const getListSensoterraDevicesQueryKey = () => {
	return ["sensoterra-devices"] as const;
};

export const getListSensoterraDevicesQueryOptions = <
	TData = Awaited<ReturnType<typeof listSensoterraDevices>>,
	TError = ListSensoterraDevices400 | ListSensoterraDevices500,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof listSensoterraDevices>>,
			TError,
			TData
		>
	>;
	request?: SecondParameter<typeof customFetch>;
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getListSensoterraDevicesQueryKey();

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof listSensoterraDevices>>
	> = ({ signal }) => listSensoterraDevices({ signal, ...requestOptions });

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof listSensoterraDevices>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListSensoterraDevicesQueryResult = NonNullable<
	Awaited<ReturnType<typeof listSensoterraDevices>>
>;
export type ListSensoterraDevicesQueryError =
	| ListSensoterraDevices400
	| ListSensoterraDevices500;

export function useListSensoterraDevices<
	TData = Awaited<ReturnType<typeof listSensoterraDevices>>,
	TError = ListSensoterraDevices400 | ListSensoterraDevices500,
>(
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listSensoterraDevices>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof listSensoterraDevices>>,
					TError,
					Awaited<ReturnType<typeof listSensoterraDevices>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListSensoterraDevices<
	TData = Awaited<ReturnType<typeof listSensoterraDevices>>,
	TError = ListSensoterraDevices400 | ListSensoterraDevices500,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listSensoterraDevices>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof listSensoterraDevices>>,
					TError,
					Awaited<ReturnType<typeof listSensoterraDevices>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListSensoterraDevices<
	TData = Awaited<ReturnType<typeof listSensoterraDevices>>,
	TError = ListSensoterraDevices400 | ListSensoterraDevices500,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listSensoterraDevices>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List all Sensoterra devices owned by the authenticated user
 */

export function useListSensoterraDevices<
	TData = Awaited<ReturnType<typeof listSensoterraDevices>>,
	TError = ListSensoterraDevices400 | ListSensoterraDevices500,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listSensoterraDevices>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions = getListSensoterraDevicesQueryOptions(options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List all Sensoterra devices owned by the authenticated user
 */
export const useSetListSensoterraDevicesQueryData = () => {
	const queryClient = useQueryClient();
	return (
		updater:
			| Awaited<ReturnType<typeof listSensoterraDevices>>
			| undefined
			| ((
					old: Awaited<ReturnType<typeof listSensoterraDevices>> | undefined,
			  ) => Awaited<ReturnType<typeof listSensoterraDevices>> | undefined),
	) => {
		queryClient.setQueriesData<
			Awaited<ReturnType<typeof listSensoterraDevices>>
		>({ queryKey: getListSensoterraDevicesQueryKey() }, updater);
	};
};

/**
 * @summary List all Sensoterra devices owned by the authenticated user
 */
export const useGetListSensoterraDevicesQueryData = () => {
	const queryClient = useQueryClient();
	return () =>
		queryClient.getQueryData<Awaited<ReturnType<typeof listSensoterraDevices>>>(
			getListSensoterraDevicesQueryKey(),
		);
};

export const getCreateSensoterraDeviceUrl = () => {
	return `/sensoterra-devices`;
};

/**
 * @summary Register a new Sensoterra device
 */
export const createSensoterraDevice = async (
	sensoterradevicesCreate: SensoterradevicesCreate,
	options?: RequestInit,
): Promise<Sensoterradevices> => {
	return customFetch<Sensoterradevices>(getCreateSensoterraDeviceUrl(), {
		...options,
		method: "POST",
		headers: { "Content-Type": "application/json", ...options?.headers },
		body: JSON.stringify(sensoterradevicesCreate),
	});
};

export const getCreateSensoterraDeviceMutationOptions = <
	TError =
		| CreateSensoterraDevice400
		| CreateSensoterraDevice403
		| CreateSensoterraDevice500
		| CreateSensoterraDevice502,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof createSensoterraDevice>>,
		TError,
		{ data: SensoterradevicesCreate },
		TContext
	>;
	request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof createSensoterraDevice>>,
	TError,
	{ data: SensoterradevicesCreate },
	TContext
> => {
	const mutationKey = ["createSensoterraDevice"];
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation &&
			"mutationKey" in options.mutation &&
			options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof createSensoterraDevice>>,
		{ data: SensoterradevicesCreate }
	> = (props) => {
		const { data } = props ?? {};

		return createSensoterraDevice(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type CreateSensoterraDeviceMutationResult = NonNullable<
	Awaited<ReturnType<typeof createSensoterraDevice>>
>;
export type CreateSensoterraDeviceMutationBody = SensoterradevicesCreate;
export type CreateSensoterraDeviceMutationError =
	| CreateSensoterraDevice400
	| CreateSensoterraDevice403
	| CreateSensoterraDevice500
	| CreateSensoterraDevice502;

/**
 * @summary Register a new Sensoterra device
 */
export const useCreateSensoterraDevice = <
	TError =
		| CreateSensoterraDevice400
		| CreateSensoterraDevice403
		| CreateSensoterraDevice500
		| CreateSensoterraDevice502,
	TContext = unknown,
>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof createSensoterraDevice>>,
			TError,
			{ data: SensoterradevicesCreate },
			TContext
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseMutationResult<
	Awaited<ReturnType<typeof createSensoterraDevice>>,
	TError,
	{ data: SensoterradevicesCreate },
	TContext
> => {
	return useMutation(
		getCreateSensoterraDeviceMutationOptions(options),
		queryClient,
	);
};
export const getGetSensoterraDeviceUrl = (sensoterraDeviceId: string) => {
	return `/sensoterra-devices/${sensoterraDeviceId}`;
};

/**
 * @summary Get a single Sensoterra device by ID
 */
export const getSensoterraDevice = async (
	sensoterraDeviceId: string,
	options?: RequestInit,
): Promise<Sensoterradevices> => {
	return customFetch<Sensoterradevices>(
		getGetSensoterraDeviceUrl(sensoterraDeviceId),
		{
			...options,
			method: "GET",
		},
	);
};

export const getGetSensoterraDeviceQueryKey = (sensoterraDeviceId: string) => {
	return ["sensoterra-devices", sensoterraDeviceId] as const;
};

export const getGetSensoterraDeviceQueryOptions = <
	TData = Awaited<ReturnType<typeof getSensoterraDevice>>,
	TError =
		| GetSensoterraDevice400
		| GetSensoterraDevice404
		| GetSensoterraDevice500,
>(
	sensoterraDeviceId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getSensoterraDevice>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ??
		getGetSensoterraDeviceQueryKey(sensoterraDeviceId);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getSensoterraDevice>>
	> = ({ signal }) =>
		getSensoterraDevice(sensoterraDeviceId, { signal, ...requestOptions });

	return {
		queryKey,
		queryFn,
		enabled: sensoterraDeviceId !== null && sensoterraDeviceId !== undefined,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof getSensoterraDevice>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSensoterraDeviceQueryResult = NonNullable<
	Awaited<ReturnType<typeof getSensoterraDevice>>
>;
export type GetSensoterraDeviceQueryError =
	| GetSensoterraDevice400
	| GetSensoterraDevice404
	| GetSensoterraDevice500;

export function useGetSensoterraDevice<
	TData = Awaited<ReturnType<typeof getSensoterraDevice>>,
	TError =
		| GetSensoterraDevice400
		| GetSensoterraDevice404
		| GetSensoterraDevice500,
>(
	sensoterraDeviceId: string,
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getSensoterraDevice>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof getSensoterraDevice>>,
					TError,
					Awaited<ReturnType<typeof getSensoterraDevice>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSensoterraDevice<
	TData = Awaited<ReturnType<typeof getSensoterraDevice>>,
	TError =
		| GetSensoterraDevice400
		| GetSensoterraDevice404
		| GetSensoterraDevice500,
>(
	sensoterraDeviceId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getSensoterraDevice>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof getSensoterraDevice>>,
					TError,
					Awaited<ReturnType<typeof getSensoterraDevice>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSensoterraDevice<
	TData = Awaited<ReturnType<typeof getSensoterraDevice>>,
	TError =
		| GetSensoterraDevice400
		| GetSensoterraDevice404
		| GetSensoterraDevice500,
>(
	sensoterraDeviceId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getSensoterraDevice>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get a single Sensoterra device by ID
 */

export function useGetSensoterraDevice<
	TData = Awaited<ReturnType<typeof getSensoterraDevice>>,
	TError =
		| GetSensoterraDevice400
		| GetSensoterraDevice404
		| GetSensoterraDevice500,
>(
	sensoterraDeviceId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getSensoterraDevice>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions = getGetSensoterraDeviceQueryOptions(
		sensoterraDeviceId,
		options,
	);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get a single Sensoterra device by ID
 */
export const useSetGetSensoterraDeviceQueryData = () => {
	const queryClient = useQueryClient();
	return (
		sensoterraDeviceId: string,
		updater:
			| Awaited<ReturnType<typeof getSensoterraDevice>>
			| undefined
			| ((
					old: Awaited<ReturnType<typeof getSensoterraDevice>> | undefined,
			  ) => Awaited<ReturnType<typeof getSensoterraDevice>> | undefined),
	) => {
		queryClient.setQueriesData<Awaited<ReturnType<typeof getSensoterraDevice>>>(
			{ queryKey: getGetSensoterraDeviceQueryKey(sensoterraDeviceId) },
			updater,
		);
	};
};

/**
 * @summary Get a single Sensoterra device by ID
 */
export const useGetGetSensoterraDeviceQueryData = () => {
	const queryClient = useQueryClient();
	return (sensoterraDeviceId: string) =>
		queryClient.getQueryData<Awaited<ReturnType<typeof getSensoterraDevice>>>(
			getGetSensoterraDeviceQueryKey(sensoterraDeviceId),
		);
};

export const getUpdateSensoterraDeviceUrl = (sensoterraDeviceId: string) => {
	return `/sensoterra-devices/${sensoterraDeviceId}`;
};

/**
 * @summary Update an existing Sensoterra device
 */
export const updateSensoterraDevice = async (
	sensoterraDeviceId: string,
	sensoterradevicesUpdate: SensoterradevicesUpdate,
	options?: RequestInit,
): Promise<Sensoterradevices> => {
	return customFetch<Sensoterradevices>(
		getUpdateSensoterraDeviceUrl(sensoterraDeviceId),
		{
			...options,
			method: "PATCH",
			headers: { "Content-Type": "application/json", ...options?.headers },
			body: JSON.stringify(sensoterradevicesUpdate),
		},
	);
};

export const getUpdateSensoterraDeviceMutationOptions = <
	TError =
		| UpdateSensoterraDevice400
		| UpdateSensoterraDevice404
		| UpdateSensoterraDevice500,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof updateSensoterraDevice>>,
		TError,
		{ sensoterraDeviceId: string; data: SensoterradevicesUpdate },
		TContext
	>;
	request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof updateSensoterraDevice>>,
	TError,
	{ sensoterraDeviceId: string; data: SensoterradevicesUpdate },
	TContext
> => {
	const mutationKey = ["updateSensoterraDevice"];
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation &&
			"mutationKey" in options.mutation &&
			options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof updateSensoterraDevice>>,
		{ sensoterraDeviceId: string; data: SensoterradevicesUpdate }
	> = (props) => {
		const { sensoterraDeviceId, data } = props ?? {};

		return updateSensoterraDevice(sensoterraDeviceId, data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type UpdateSensoterraDeviceMutationResult = NonNullable<
	Awaited<ReturnType<typeof updateSensoterraDevice>>
>;
export type UpdateSensoterraDeviceMutationBody = SensoterradevicesUpdate;
export type UpdateSensoterraDeviceMutationError =
	| UpdateSensoterraDevice400
	| UpdateSensoterraDevice404
	| UpdateSensoterraDevice500;

/**
 * @summary Update an existing Sensoterra device
 */
export const useUpdateSensoterraDevice = <
	TError =
		| UpdateSensoterraDevice400
		| UpdateSensoterraDevice404
		| UpdateSensoterraDevice500,
	TContext = unknown,
>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof updateSensoterraDevice>>,
			TError,
			{ sensoterraDeviceId: string; data: SensoterradevicesUpdate },
			TContext
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseMutationResult<
	Awaited<ReturnType<typeof updateSensoterraDevice>>,
	TError,
	{ sensoterraDeviceId: string; data: SensoterradevicesUpdate },
	TContext
> => {
	return useMutation(
		getUpdateSensoterraDeviceMutationOptions(options),
		queryClient,
	);
};
export const getDeleteSensoterraDeviceUrl = (sensoterraDeviceId: string) => {
	return `/sensoterra-devices/${sensoterraDeviceId}`;
};

/**
 * @summary Delete a Sensoterra device
 */
export const deleteSensoterraDevice = async (
	sensoterraDeviceId: string,
	options?: RequestInit,
): Promise<Sensoterradevices> => {
	return customFetch<Sensoterradevices>(
		getDeleteSensoterraDeviceUrl(sensoterraDeviceId),
		{
			...options,
			method: "DELETE",
		},
	);
};

export const getDeleteSensoterraDeviceMutationOptions = <
	TError =
		| DeleteSensoterraDevice400
		| DeleteSensoterraDevice404
		| DeleteSensoterraDevice500,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof deleteSensoterraDevice>>,
		TError,
		{ sensoterraDeviceId: string },
		TContext
	>;
	request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof deleteSensoterraDevice>>,
	TError,
	{ sensoterraDeviceId: string },
	TContext
> => {
	const mutationKey = ["deleteSensoterraDevice"];
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation &&
			"mutationKey" in options.mutation &&
			options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof deleteSensoterraDevice>>,
		{ sensoterraDeviceId: string }
	> = (props) => {
		const { sensoterraDeviceId } = props ?? {};

		return deleteSensoterraDevice(sensoterraDeviceId, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type DeleteSensoterraDeviceMutationResult = NonNullable<
	Awaited<ReturnType<typeof deleteSensoterraDevice>>
>;

export type DeleteSensoterraDeviceMutationError =
	| DeleteSensoterraDevice400
	| DeleteSensoterraDevice404
	| DeleteSensoterraDevice500;

/**
 * @summary Delete a Sensoterra device
 */
export const useDeleteSensoterraDevice = <
	TError =
		| DeleteSensoterraDevice400
		| DeleteSensoterraDevice404
		| DeleteSensoterraDevice500,
	TContext = unknown,
>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof deleteSensoterraDevice>>,
			TError,
			{ sensoterraDeviceId: string },
			TContext
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseMutationResult<
	Awaited<ReturnType<typeof deleteSensoterraDevice>>,
	TError,
	{ sensoterraDeviceId: string },
	TContext
> => {
	return useMutation(
		getDeleteSensoterraDeviceMutationOptions(options),
		queryClient,
	);
};
